import React from 'react';
import Datas from '../../data/counter/number-counter-default.json';
import { Container, Row, Col } from 'react-bootstrap';
import CountUp from 'react-countup';
import { Styles } from "../styles/numberCounter.js";

const NumberCounterDefault = () => {

        return (
            <Styles>
                {/* Counter Area */}
                <section className="counter-area" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/${Datas.backgroundImage})` }}>
                    <Container>
                        <Row>
                            <Col md="12">
                                <div className="sec-title text-center">
                                    <h4>{Datas.secTitle}</h4>
                                </div>
                            </Col>
                            {/* Academic Achievement */}
                            <Col md="3" xs="6">
                                <div className="counter-box">
                                    <div className="counter-icon">
                                        <i className="las la-trophy"></i>
                                    </div>
                                    <div className="counter-number">
                                        <h4><CountUp end={97} duration={3} suffix="%" /></h4>
                                        <p>Highest ICSE Score</p>
                                    </div>
                                </div>
                            </Col>

                            {/* Library Books */}
                            <Col md="3" xs="6">
                                <div className="counter-box">
                                    <div className="counter-icon">
                                        <i className="las la-book-reader"></i>
                                    </div>
                                    <div className="counter-number">
                                        <h4><CountUp end={15000} duration={3} suffix="+" /></h4>
                                        <p>Library Books</p>
                                    </div>
                                </div>
                            </Col>

                            {/* Teaching Staff */}
                            <Col md="3" xs="6">
                                <div className="counter-box">
                                    <div className="counter-icon">
                                        <i className="las la-chalkboard-teacher"></i>
                                    </div>
                                    <div className="counter-number">
                                        <h4><CountUp end={60} duration={3} suffix="+" /></h4>
                                        <p>Qualified Teachers</p>
                                    </div>
                                </div>
                            </Col>

                            {/* Digital Classrooms */}
                            <Col md="3" xs="6">
                                <div className="counter-box">
                                    <div className="counter-icon">
                                        <i className="las la-laptop"></i>
                                    </div>
                                    <div className="counter-number">
                                        <h4><CountUp end={100} duration={3} suffix="%" /></h4>
                                        <p>Digital Classrooms</p>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>
            </Styles>
        )
    }


export default NumberCounterDefault;
